export default "__VITE_ASSET__uF1jB6iT__"